import { render, staticRenderFns } from "./TopicGroup.vue?vue&type=template&id=7d951bec&scoped=true&"
import script from "./TopicGroup.vue?vue&type=script&lang=js&"
export * from "./TopicGroup.vue?vue&type=script&lang=js&"
import style0 from "./TopicGroup.vue?vue&type=style&index=0&id=7d951bec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d951bec",
  null
  
)

export default component.exports